import * as RasaInput from '../../components/rasa-input'
import * as Types from './types'

export const SERVER_RESOURCE = '/schedules'

export const FETCH_SCHEDULES = 'FETCH_SCHEDULES'
export const ADD_SCHEDULE = 'ADD_SCHEDULE'
export const UPDATE_SCHEDULE = 'UPDATE_SCHEDULE'
export const UPDATE_SCHEDULE_INLINE = 'UPDATE_SCHEDULE_INLINE'
export const MODAL_SCHEDULE = 'MODAL_SCHEDULE'

export interface FormFields {
  cutoff_offset?: number,
  days?: string,
  frequency?: string,
  id?: number,
  name?: string,
  time?: string,
  weeks?: string,
}

export const DAILY: Types.Frequency = {
  description: 'Every Day',
  key: 'daily',
}

export const WEEKLY: Types.Frequency = {
  description: 'Weekly',
  key: 'weekly',
}

export const BIWEEKLY: Types.Frequency = {
  description: 'Every other week',
  key: 'biweekly',
}

export const MONTHLY: Types.Frequency = {
  description: 'Monthly',
  key: 'monthly',
}

export const FREQUENCIES: Types.Frequency[] = [DAILY, WEEKLY, BIWEEKLY, MONTHLY]

export const emptyModalSchedule: Types.FormFields = {
  cutoff_offset: 90,
  days: 'MTWRF',
  frequency: WEEKLY.key,
  time: '09:00',
  weeks: '1,2,3,4,5',
}

export const FormValidators: {[key: string]: RasaInput.Validator} = {
  [Types.FormFieldNames.CutoffOffset]: RasaInput.validatePresent,
  [Types.FormFieldNames.Days]: RasaInput.validatePresent,
  [Types.FormFieldNames.Name]: RasaInput.validatePresent,
  [Types.FormFieldNames.Time]: RasaInput.validateTime,
}

export const MON: Types.FrequencyUnit = { key: 'M', name: 'Mon' }
export const TUE: Types.FrequencyUnit = { key: 'T', name: 'Tue' }
export const WED: Types.FrequencyUnit = { key: 'W', name: 'Wed' }
export const THU: Types.FrequencyUnit = { key: 'R', name: 'Thu' }
export const FRI: Types.FrequencyUnit = { key: 'F', name: 'Fri' }
export const SAT: Types.FrequencyUnit = { key: 'S', name: 'Sat' }
export const SUN: Types.FrequencyUnit = { key: 'U', name: 'Sun' }

export const ALL_DAYS: Types.FrequencyUnit[] = [MON, TUE, WED, THU, FRI, SAT, SUN]

export const WEEK1: Types.FrequencyUnit = { key: '1', name: 'First Week'}
export const WEEK2: Types.FrequencyUnit = { key: '2', name: 'Second Week'}
export const WEEK3: Types.FrequencyUnit = { key: '3', name: 'Third Week'}
export const WEEK4: Types.FrequencyUnit = { key: '4', name: 'Fourth Week'}
export const WEEK5: Types.FrequencyUnit = { key: '5', name: 'Fifth Week'}
export const ALL_WEEKS: Types.FrequencyUnit[] = [WEEK1, WEEK2, WEEK3, WEEK4, WEEK5]

export const ODD_WEEK: Types.FrequencyUnit = { key: '1', name: 'Odd Weeks'}
export const EVEN_WEEK: Types.FrequencyUnit = { key: '2', name: 'Even Weeks'}
export const BIWEEKLY_WEEKS: Types.FrequencyUnit[] = [ODD_WEEK, EVEN_WEEK]

export const FETCH_VERSION_FORMAT = 'v1' // version that includes holidays



// WEBPACK FOOTER //
// ./src/pages/schedules/constants.ts